(function () {
    'use strict';

    angular.module('swif.ui')
    .component('swifMenu', {
        templateUrl: 'partials/ui/menu.html',
        controller: MenuController
    });

    /**
     * @ngdoc directive
     * @name swif.ui:swifMenu
     * @module swif.ui
     * @restrict E
     * @description the global menu of the app

     * @usage
        <swif-menu></swif-menu>
    **/
    function MenuController($rootScope, $location, $scope, $localStorage, collections, dataService, settingsService, actionService,
        msgService, swifAlerter, swifFrameworkCartService, swifFilterService, userService, swifModule,
        swifOpenbaseLanguageService
    ){
        'ngInject';
        var $ctrl = this;
        var swif = {
            action: actionService,
            user: userService,
            settings: settingsService,
            collections: collections,
            data: dataService,
            message: msgService,
            alerter: swifAlerter,
            cart: swifFrameworkCartService,
            filter: swifFilterService,
            language: swifOpenbaseLanguageService
        };
        this.refreshgroups = $location.search().refreshgroups ? true:false;
        this.settings = swif.settings;
        this.alerter = swif.alerter.getAlerterObject();
        this.applyFilter = swif.alerter.applyAlertFilter;
        this.cart = swif.cart.cart;
        this.cart_info = swif.cart.info;
        this.emptyCart = swif.cart.emptyCart;
        this.emptyCartByType = swif.cart.emptyCart;
        this.fullView = true;
        this.clickOnCartType =  clickOnCartType;
        this.getCartItemTypeName = getCartItemTypeName;
        this.manageAlerts = manageAlerts;
        this.checkIsUserSupplier = checkIsUserSupplier;

        this.dispatchUserAction = dispatchUserAction;
        this.updateUserGroups = updateUserGroups;

        // check if user is an external provider
        $scope.providersProfile = swif.settings.app.features.providersProfile;
        $scope.isSupplier = false;
        this.checkIsUserSupplier();
        $rootScope.$on('authenticationEvent', () => {
            this.checkIsUserSupplier();
        });


        function checkIsUserSupplier () {
            var user = swif.user.getAuthenticatedUserData();
            if (user) {
                $scope.isSupplier = user.is_supplier;
            } else {
                $scope.isSupplier = false;
            }
        }

        $ctrl.menuClass = function(menuName) {
            var className = "";
            if ($ctrl.currentActiveMenu===menuName){
                className = "activeMenu";
            }
            return className;
        };

        $ctrl.currentActiveMenu = "";

        // Displays a "1" label on About link to show OpenGST Lab presence.
        this.haveSeenLab = $localStorage.haveSeenLab;

        this.removeLabNotif = function() {
            this.haveSeenLab = true;
            $localStorage.haveSeenLab = true;
        }

        //here we catch all the location patch changes
        $scope.$on('$routeChangeSuccess', function(){
            var currentLocation = $location.path().substring(1);
            //#/configuration/ -> configuration
            if ($location.path().substring(0, 15) === '/configuration/'){
                $ctrl.currentActiveMenu = "configuration";
                // #/.../configuration_view -> configuration
            }else if (_.endsWith($location.path(), '/configuration_view' )){
                $ctrl.currentActiveMenu = "configuration";
                    }else{
                        // #/interventions/ --> module inter
                        // #/patrimoine/ --> module patrimoine
                        // #/reservations/ --> module réservation
                        // #/achats-stocks/ --> module achats
                        // #/parcauto/ --> module parc auto
                        // #/fluid/ --> module fluids
                        $ctrl.currentActiveMenu = currentLocation.substring(0, currentLocation.indexOf('/'));
                    }
        });


        swif.settings.initialize().then(function (settings) {
            $ctrl.modules = swifModule.modules;
            $ctrl.settings = settings;
            swif.settings = settings;
            var watched = '$ctrl.settings.localStorage.' + settings.app.db + '.authenticated_user_data';
            $scope.$watch(watched, function (newV) {
                if (newV !== $ctrl.authenticatedUserData) {
                    $ctrl.authenticatedUserData = newV;
                    $ctrl.access_rights = userService.getAccessRights();
                    $ctrl.fullView = $ctrl.access_rights.openstc_full_view;
                    $ctrl.userActions = swif.action.getActions('user', 'menu');
                }
                if ($ctrl.authenticatedUserData){
                    var user = swif.user.getAuthenticatedUser();
                    if (user && settings.app.db) {
                        if (settings.app.db ===  user.db) {
                            swif.alerter.loadAlertFilters();
                        }
                    }
                }
            });
        });

        function preValidate (data) {
            var preValidated = true;
            if (data.action.id === 'logout'){
                //add the token to the URL
                var url = data.action.http.url;
                url = url.replace(':id', swif.settings.get('token'));
                data.action.http.url = url;
            } else if(data.action.id === 'editpreference') {
                swif.language.applyLang(data.model.context_lang);
            }
            return preValidated;
        }

        function callbackActions (error, data) {
            // action, result, model
            if (error) {
                swif.message.addError(error);
            } else {
                if (data.action.id === 'logout') {
                    data.action.http.url.replace(swif.settings.get('token'), ':id');
                    $location.path('/logout');
                } else if(data.action.id === 'resetpassword') {
                    if (data.result.new_password) {
                        $location.path('/logout');
                        swif.message.addInfo('Your password has been changed successfully');
                    } else {
                        swif.message.addInfo(data.result.error);
                    }
                } else if (data.action.id === 'editpreference') {
                    dataService.updateObj(data.model, $ctrl.authenticatedUserData);
                }
            }
        }


        function manageAlerts () {
            var action = swif.action.getActionById('filter', 'menu', 'manage');
            if (action) {
                swif.action.dispatch('filter', action);
            }
        }

        function getCartItemTypeName (type) {
            return swif.settings.getContentType(type).title;
        }

        function clickOnCartType (type) {
            var ids = swif.cart.getCartItemsIds(type);
            var contentType = swif.settings.getContentType(type);
            var cid = contentType.alert.collection_id;
            var action = swif.action.getActionById(contentType.id, 'views', 'table');
            if (action) {
                var filter = {};
                swif.data.addExtraFilter(filter, 'cartItems', 'id', 'in', ids);
                swif.filter.loadFilteredCollection(cid, action, filter);
            }
        }

        function updateUserGroups () {
            //hack drop the user.id
            var user = settingsService.get('authenticated_user');
            delete user.id;
            settingsService.set('authenticated_user', user);
            userService._setAuthenticatedUserData();
        }

        function dispatchUserAction (action) {
            swif.action.dispatch(
                'user',
                action,
                $ctrl.authenticatedUserData,
                {
                    preValidate: preValidate,
                    callback: callbackActions
                }
            );
        }
    }

})();
